import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import FormField from "./FormField";
import axios from "axios";
import "./audit-popup-form.scss";
import { getLeadMeta } from "../../utils/getLeadMeta";

const indianMobileRule = /^[6-9]\d{9}$/;

const AuditPopupForm = ({ onSuccess }) => {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [website, setWebsite] = useState("");

  const [nameError, setNameError] = useState("");
  const [phoneError, setPhoneError] = useState("");

  const [loading, setLoading] = useState(false);
  const [formInvalid, setFormInvalid] = useState(true);

  const [thankyoumsg, setThankyoumsg] = useState("");
  const [buttonText, setButtonText] = useState(
    "Book Free Audit + Consultation →",
  );
  const [buttonClass, setButtonClass] = useState("");
  const history = useHistory();

  const validateName = (value) => {
    const trimmedValue = value.trim();
    setName(value);

    if (trimmedValue.length === 0) {
      setNameError("Please enter your name");
      return false;
    }

    setNameError("");
    return true;
  };

  const validatePhone = (value) => {
    const cleanedValue = String(value).replace(/\D/g, "").slice(0, 10);

    setPhone(cleanedValue);

    if (cleanedValue.length === 0) {
      setPhoneError("Please enter your contact number");
      return false;
    }

    if (!indianMobileRule.test(cleanedValue)) {
      setPhoneError("Enter a valid 10 digit Indian mobile number");
      return false;
    }

    setPhoneError("");
    return true;
  };

  useEffect(() => {
    const isNameValid = name.trim().length > 0;
    const isPhoneValid = indianMobileRule.test(String(phone).trim());

    setFormInvalid(!(isNameValid && isPhoneValid));
  }, [name, phone]);

  const resetFormState = () => {
    setTimeout(() => {
      setButtonText("Book Free Audit + Consultation →");
      setButtonClass("");
      setThankyoumsg("");
    }, 5000);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const isNameValid = validateName(name);
    const isPhoneValid = validatePhone(phone);

    if (!isNameValid || !isPhoneValid || loading) return;

    try {
      setLoading(true);
      setButtonText("Submitting...");
      setButtonClass("loading");
      const meta = await getLeadMeta();
      const response1 = await axios.post("/sendmail", {
        timeout: 2000,
        data: {
          fname: name,
          email: "",
          message: "Audit popup lead",
          phone: phone,
          website: website,
          checkbox: false,
          page: "audit-popup (Landing Page)",
          budget: "N/A",
          source: meta.source,
          moreInfo: `IP: ${meta.ip} | Location: ${meta.city}, ${meta.country} | Date: ${meta.date} | Time: ${meta.time} IST | Device: ${meta.deviceName} (${meta.deviceType})`,
        },
      });

      const sheetStatus = response1.data?.sheetStatus;

      if (sheetStatus === "success") {
        // --- DATA LAYER PUSH START ---
        // This fires immediately so it's captured even if the user closes the tab
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "pop_up_form_submission_success_message", // Same trigger name for GTM
          form_name: "pop_up_audit_popup_form",
          form_location: "popup_modal",
          lead_type: "audit_request",
        });
        // --- DATA LAYER PUSH END ---

        setLoading(false);
        setThankyoumsg("Message Sent.");
        setButtonText("Message Sent. We will reply you soon!");
        setButtonClass("sent-msg");

        setName("");
        setPhone("");
        setWebsite("");
        setNameError("");
        setPhoneError("");

        if (onSuccess) {
          // We wait 2.5s so they can see the "Message Sent" text before the popup closes
          setTimeout(() => {
            onSuccess();
          }, 2500);
        }

        history.push("/thankyou");
        resetFormState();
      } else if (sheetStatus === "duplicate") {
        setLoading(false);
        setThankyoumsg("");
        setButtonText("You have already submitted this form.");
        setButtonClass("");
      } else {
        setLoading(false);
        setThankyoumsg("");
        setButtonText("Something went wrong. Sorry!");
        setButtonClass("");
      }
    } catch (err) {
      console.error("Submission error:", err);
      setLoading(false);
      setThankyoumsg("");
      setButtonText("Something went wrong. Sorry!");
      setButtonClass("");
    }
  };

  return (
    <form className="audit-popup-form" onSubmit={handleSubmit} noValidate>
      <FormField
        label="Your Name *"
        value={name}
        fieldName="name"
        type="text"
        className={`field field--compact ${nameError ? "field-error" : ""}`}
        placeholder="Enter your full name"
        fieldFn={validateName}
      />
      {nameError && <div className="error">{nameError}</div>}

      <div className="honeypot-field" aria-hidden="true">
        <label htmlFor="popup-website">Website</label>
        <input
          id="popup-website"
          name="website"
          type="text"
          value={website}
          onChange={(e) => setWebsite(e.target.value)}
          tabIndex="-1"
          autoComplete="off"
        />
      </div>

      <FormField
        label="Your Contact Number *"
        value={phone}
        fieldName="phone"
        type="tel"
        className={`field field--compact ${phoneError ? "field-error" : ""}`}
        placeholder="Enter your contact number"
        fieldFn={validatePhone}
        inputMode="numeric"
        maxLength="10"
        pattern="[6-9][0-9]{9}"
      />
      {phoneError && <div className="error">{phoneError}</div>}

      <button
        type="submit"
        className={`submit-button ${buttonClass}`}
        disabled={formInvalid || loading}
      >
        {loading ? "Submitting..." : buttonText}
      </button>

      {thankyoumsg && (
        <div id="popup-form-success-message" className="success-message">
          {thankyoumsg}
        </div>
      )}
    </form>
  );
};

export default AuditPopupForm;
